<template>
<v-container fluid>
  <v-card>
    <v-card-text>
      <v-form 
        ref="form" 
        v-model="valid" 
        :lazy-validation="lazy">
        <v-row>
          
          <v-col cols="12" md="12">
            
          <select-tipo-participante :id-tipo-participante-prop="idTipoParticipante" :fn-change="setIdTipoParticipante" :requerido="true"></select-tipo-participante>
          <v-text-field v-if="idTipoParticipante == 1 || idTipoParticipante == 2"
               v-model="nombreGrupo"
             :loading="loading"
              label="Descripción del Grupo"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
           <v-col v-if="idTipoParticipante == 1 || idTipoParticipante == 3" cols="12" md="12">
          <select-tipo-relacion v-if="idTipoParticipante == 1 || idTipoParticipante == 3" :id-tipo-relacion-prop="idRelacion" :fn-change="setIdRelacionUG" :requerido="true"></select-tipo-relacion>
           </v-col>
           </v-col>
          </v-col>
        </v-row> 
          <v-row>
                <v-col v-if="idTipoParticipante == 1" cols="12" md="4">
                    <select-campus v-if="idTipoParticipante == 1" :id-campus-prop="idCampus" :fn-change="setIdCampus" :requerido="true"></select-campus>
                  </v-col>
                  <v-col v-if="idTipoParticipante == 1" cols="12" md="4">
                    <select-division v-if="idTipoParticipante == 1" :id-campus="idCampus" :id-division-prop="idDivision" :fn-change="setIdDivision" :requerido="false"></select-division>
                  </v-col>
                  <v-col v-if="idTipoParticipante == 1" cols="12" md="4">
                    <select-dep-plan-unidad v-if="idTipoParticipante == 1" :id-campus="idCampus" :id-division="idDivision" :id-dep-plan-unidad-prop="idDepPlanUnidad" :fn-change="setIdDepPlanUnidad" :requerido="false"></select-dep-plan-unidad>
                  </v-col>    
        
                <v-col v-if="idTipoParticipante == 2" cols="12" md="12">
                  <v-alert v-if="idTipoParticipante == 2"
      outlined
      type="info"
      text>
      Para agregar un grupo de participantes por favor de adjuntar un archivo en Excel con los nombres y correos de las personas a participar 
      en la encuesta, si no cuenta con el formato lo puede descargar de la siguiente liga: 
    </v-alert>
                </v-col>
          <v-col v-if="idTipoParticipante == 2" cols="12" md="4">
 <v-btn v-if="idTipoParticipante == 2" color="success"
          @click="download"
          >
      Plantilla de Excel
    </v-btn>
    {{file}}
          </v-col>
          <v-col v-if="idTipoParticipante == 2" cols="12" md="8">
                   <v-file-input v-if="idTipoParticipante == 2"
                    :rules="[(v) => !!v || 'Campo obligatorio']"
                    v-model="file"
                    placeholder="Agregar un archivo"
                    prepend-icon="mdi-paperclip"
                    label="Agregar un archivo"
                    @change="created" 
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                    outlined
                    required
                    dense
                ></v-file-input>
                </v-col>
                </v-col>
                 <v-col cols="12" md="12" v-if="idTipoParticipante == 3">
                 <buscador-empleado v-if="idTipoParticipante == 3 && idRelacion==2" :fn-seleccionar-empleado="fnSeleccionarEmpleado" :ban-limpiar-datos="banLimpiarDatos"></buscador-empleado>
                <buscador-alumno v-if="idTipoParticipante == 3 && idRelacion==1" :fn-seleccionar-alumno="fnSeleccionarAlumno" :ban-limpiar-datos="banLimpiarDatos"></buscador-alumno>
             </v-col>
             </v-row>
            <v-row>
            <v-col  v-if="idTipoParticipante == 3" cols="12" md="8">
            <v-text-field
             v-if="idTipoParticipante == 3"
              :loading="loading"
             v-model="nombreTipoParticipante3"
              label="Nombre"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              
              outlined
              required
              dense
            ></v-text-field>
            <v-text-field
             v-if="idTipoParticipante == 3"
              :loading="loading"
               v-model="correoTipoParticipante3"
              label="Correo electrónico"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              prepend-inner-icon="mail"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col  v-if="idTipoParticipante == 4" cols="12" md="6">
            <v-text-field
             v-if="idTipoParticipante == 4"
              v-model="nombreTipoParticipante4"
              :loading="loading"
              label="Nombre"
              :rules="[(v) => !!v || 'Campo obligatorio']"
              outlined
              required
              dense
            ></v-text-field>
            <v-text-field
             v-if="idTipoParticipante == 4"
             v-model="correoTipoParticipante4"
              :loading="loading"
              label="Correo electrónico"
              prepend-inner-icon="mail"
              :rules="checkboxEnviarCorreo == true ? mailRules : []"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
      </v-row>    
      <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  large
                  color="success"
                  :disabled="!valid"
                  :loading="loadingSave"
                  @click="cargarNumeroParticipantes"
                >
                <v-icon class="mr-2">mdi-floppy</v-icon>
                  guardar
                </v-btn>
              </v-col>
              
            </v-row>
      </v-form>   
    </v-card-text>
    <v-card-actions>
  <v-spacer></v-spacer>
  <v-row justify="center">
    
  </v-row>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>

<v-dialog
      v-model="dialog2"
      max-width="900"
       persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Agregar Participantes
        </v-card-title>
        <v-card-text>
         Se agregará(n) {{this.numeroParticipantes}} participante(s) a la encuesta: {{objEncuesta.nombreEncuesta}} y en caso de estar activada la opción se enviará la
          liga para su llenado a los correos electrónicos, ¿desea continuar?
          
       <v-alert v-if="isMailsValid==false"
      outlined
      type="error"
      text>
      Se encontraron correos inválidos en las filas: {{this.mailsMail}}
     
    </v-alert>
        <v-data-table v-if="this.idTipoParticipante==2"
        :headers="headers"
        :items="items2"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
      <template v-slot:item.estatus="{ item }">
           
            <span v-if="item.estatus=='correcto'" class="success--text text-h6">{{item.estatus}}</span>
            <span v-if="item.estatus=='incorrecto'" class="red--text text-h6">{{item.estatus}}</span>
         
        </template>
      </v-data-table>

      
        <v-data-table v-if="this.idTipoParticipante==1"
        :headers="headers2"
        :items="itemsTipoGrupo1"
        :loading="loading"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
      <template v-slot:item.acciones="{ item, item2 }">
          <v-row>
            <v-col cols="3" style="display:ruby;">            
              <v-btn 
                  large
                  color="error"
                  @click="eliminarParticipante(item.mail)"
                >
               <v-icon class="mr-2"> mdi-delete</v-icon> 
                  
                </v-btn>
            </v-col>
          </v-row>
        </template>
        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
          :disabled="!isMailsValid"
         
           class="mx-2"
        color="success"
            :loading="loadingSave"
           @click="guardarGrupoParticipantes"
          >
          <v-icon class="mr-2">check</v-icon>
          Aceptar
          </v-btn>
           <v-btn
           class="mx-2"
             color="error"
            text
            :loading="loadingSave"
            @click="dialog2 = false"
          >
          <v-icon class="mr-2">cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



<v-dialog
      v-model="dialogErorExcel"
      max-width="500"
       persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Se encontraron errores en el archivo Excel
        </v-card-title>
        <v-card-text>
         En las filas {{this.numeroParticipantes}} 
       
        
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
          :disabled="!isMailsValid"
         
           class="mx-2"
        color="success"
            :loading="loadingSave"
           @click="guardarGrupoParticipantes"
          >
          <v-icon class="mr-2">check</v-icon>
          Aceptar
          </v-btn>
           <v-btn
           class="mx-2"
             color="error"
            text
            :loading="loadingSave"
            @click="dialog2 = false"
          >
          <v-icon class="mr-2">cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-snackbar
    key="snackbarFormEncuestaRol"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>

import XLSX from 'xlsx';
import {postEncuestaParticipanteTipoUno,sendExcel,postCrearEiEncuestaParticipanteTipo3, postCrearEiEncuestaParticipanteTipo4, getNumeroParticipantes, postEncuestaParticipante} from "@/api";
export default {
  name: "FormParticipante",
  components: {    
    SelectTipoParticipante: () => import("../comunes/SelectTipoParticipante"),
    SelectTipoRelacion: () => import("../comunes/SelectRelacionUG.vue"),
    SelectCampus: () => import("../comunes/SelectCampus"),
    SelectDivision: () => import("../comunes/SelectDivisionR"),
    SelectDepPlanUnidad: () => import("../comunes/SelectDepPlanUnidadR"),
    BuscadorEmpleado: () => import("../comunes/BuscadorEmpleado"),
    BuscadorAlumno: () => import("../comunes/BuscadorAlumno"),
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true
    },
    flagInit:{
      type: Number,
      default: 0
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: false,
      loadingSave: false,
      snackbar: false,
      snackbarColor: '',
      search: "",
      snackbarTexto: '',
      valid: false,
      lazy: false,
      banLimpiarDatos: 0,
     // objGrupoParticipanteSave:{},
      idTipoParticipante:null,
      nombreGrupo:null,
      descripcionParticipante:null,
      idRelacion:null,
      flag2:2,
      
      relacion:null,
      idCampus: null,
      campus: null,
      idDivision: null,
      division: null,
      idDepPlanUnidad: null,
      depPlanUnidad: null,
      dialog: false,
      dialog2: false,
      dialogErorExcel: false,
      numeroParticipantes:null,
      nombreTipoParticipante3: null,
      correoTipoParticipante3: null,
      nombreTipoParticipante4: null,
      checkboxEnviarCorreo:true,
      correoTipoParticipante4: '',
      nueTipoParticipante3:null,
      fileConvertido:null,
      mailsMail:'',
       isMailsValid: true,
       headers: [
        { align: "left", text: "Nombre", value: "nombre" },
        { align: "left", text: "Correo", value: "mail" },
        { align: "left", text: "Estatus del correo", value: "estatus" },
      ],
         headers2: [
        { align: "left", text: "Nombre", value: "nombre" },
        { align: "left", text: "Correo", value: "mail" },
        { align: "left", text: "Acciones", value: "acciones" },
      ],
      itemsTipoGrupo1:[],
      items2: [],
      items: [
          { Nombre: 'Ana Gabriela Olmos Cordero', Mail: 'olmos.ag@ugto.mx' },
          { Nombre: 'Nombre 2', Mail: 'correo2@ugto.mx' }
      ],
      file:null,
       mailRules: this.createMailRules(),
    
    };
  },
  computed: {
  },
  watch: {
    flagInit: {
      handler (newValue, oldValue) {
        this.inicializarFormulario();
			}
    },
  
},
    
  mounted () {
    this.inicializarFormulario();
  },
   
 
  methods: {
createMailRules() {
      return [
        (v) => !!v || "Este campo es requerido.",
        (v) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Por favor ingrese un correo electrónico válido";
        },
      ];
    },
 inicializarFormulario(){
      var self = this;
      self.loading = true;
      if(this.$refs.form != undefined){
        this.$refs.form.resetValidation();
      }
      self.loading = false;
    },
    inicializarFormularioDef(){
          var self = this;
      self.loading = true;
      
      if(this.$refs.form != undefined){
        this.$refs.form.resetValidation();
      }
      self.idTipoParticipante=null;
      self.nombreGrupo=null;
      self.descripcionParticipante=null;
      self.idRelacion=null;
      self.relacion=null;
      self.idCampus= null;
      self.campus= null;
      self.idDivision= null;
      self.division= null;
      self.idDepPlanUnidad= null;
      self.depPlanUnidad= null;
      self.numeroParticipantes=null;
      self.nombreTipoParticipante3= null;
      self.correoTipoParticipante3= null;
      self.nueTipoParticipante3=null;
      self.nombreTipoParticipante4= null;
      self.correoTipoParticipante4= null;
      self.fileConvertido=null;
      self.file=null;
      self.loading = false;
      self.banLimpiarDatos++;
    },
    fnSeleccionarEmpleado(objEmpleado){
       if(objEmpleado == undefined){
        this.nombreTipoParticipante3= '';
        this.correoTipoParticipante3 = '';
        this.nueTipoParticipante3='';
      }
      else{
        this.nombreTipoParticipante3= objEmpleado.nombre;
        this.correoTipoParticipante3 = objEmpleado.correo;
        this.nueTipoParticipante3=objEmpleado.nue;
      }
      
    },
    fnSeleccionarAlumno(objAlumno){
       if(objAlumno == undefined){
        this.nombreTipoParticipante3= '';
        this.correoTipoParticipante3 = '';
        this.nueTipoParticipante3='';
        this.idCampus='';
        this.campus='';
        this.idDivision='';
        this.division='';
        this.idDepPlanUnidad='';
        this.depPlanUnidad='';

      }
      else{
        this.nombreTipoParticipante3= objAlumno.nombre;
        this.correoTipoParticipante3 = objAlumno.correo;
        this.nueTipoParticipante3=objAlumno.nua;
        this.idCampus=objAlumno.idCampus;
        this.campus=objAlumno.campus;
        this.idDivision=objAlumno.idDivision;
        this.division=objAlumno.division;
        this.idDepPlanUnidad=objAlumno.idDepPlanUnidad;
        this.depPlanUnidad=objAlumno.depPlanUnidad;
      }
      
    },
    async cargarNumeroParticipantes(){
    var self = this;
    let response;
    let idDivisionV;
    if(this.idTipoParticipante==1){
    if(this.idDivision==1||this.idDivision==2||this.idDivision==3||this.idDivision==4||this.idDivision==5||this.idDivision==6||this.idDivision==7||this.idDivision==8||this.idDivision==9){
      idDivisionV="0"+this.idDivision;
    }
    else{
      idDivisionV=this.idDivision;
    }
    self.loadingSave = true;
    try{
          response = await getNumeroParticipantes(this.idRelacion, this.idCampus, idDivisionV, this.idDepPlanUnidad);
          if (response.data.flag === true) {
              if (response.data.message === "Consulta correcta" ) {
                var array = [];
            self.itemsTipoGrupo1 = response.data.data;
            self.numeroParticipantes=self.items2.length;
            for (var i=0; i < this.itemsTipoGrupo1.length; i++) {
            if(this.idRelacion==2){
                 array.push({nombre:this.itemsTipoGrupo1[i]['nombre'], mail:this.itemsTipoGrupo1[i]['correo']});	
            }
            else{
              if(this.idRelacion==1){
 array.push({nombre:this.itemsTipoGrupo1[i]['nombreEstudiante'], mail:this.itemsTipoGrupo1[i]['correoElectronico']});	
              }
            }
           
            }
            self.itemsTipoGrupo1=array;
            this.dialog2=true;
            }
          } 
            self.loadingSave = false;
      }
      catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "FormEncuestaRol: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        }
        else{
          if(this.idTipoParticipante==2){
    let datoIncorrecto=false;     
          var reader = new FileReader();
         
    for (var i=0; i < this.fileConvertido.length; i++) {
   
   if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.fileConvertido[i]['Mail'])){
  this.items2.push({nombre:this.fileConvertido[i]['Nombre'], mail:this.fileConvertido[i]['Mail'], estatus:"correcto"});
  } else {
    this.items2.push({nombre:this.fileConvertido[i]['Nombre'], mail:this.fileConvertido[i]['Mail'], estatus:"incorrecto"});	
    this.isMailsValid=false;
    this.mailsMail=this.mailsMail+ (i+2)+",";
  }
   }
    
   
         this.numeroParticipantes=this.fileConvertido.length; 
          this.dialog2=true;
         
          }
        if(this.idTipoParticipante==3||this.idTipoParticipante==4){
           this.numeroParticipantes=1;
           this.dialog2=true;       
       }
     }
    },
    created(){
      const reader = new FileReader();
            reader.addEventListener("load", () => {  
          var data = new Uint8Array(reader.result);
           var workbook = XLSX.read(data, {type: 'array'});
           let sheetName = workbook.SheetNames[0]
           let worksheet = workbook.Sheets[sheetName];
           this.fileConvertido=(XLSX.utils.sheet_to_json(worksheet));
           }, false);
            reader.readAsArrayBuffer(this.file);      
    },
    async guardarGrupoParticipantes(){
      var self = this;
      if (self.$refs.form.validate()) {
        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";   
        let idDivisionV;
    if(this.idDivision==1||this.idDivision==2||this.idDivision==3||this.idDivision==4||this.idDivision==5||this.idDivision==6||this.idDivision==7||this.idDivision==8||this.idDivision==9){
      idDivisionV="0"+this.idDivision;
    }
    else{
      idDivisionV=this.idDivision;
    }
     try {
          let response;   
      if(this.idTipoParticipante==1){
        var arregloFormatTipoParticipante3=new Array();
      for (var i=0; i < (this.itemsTipoGrupo1.length); i++) {
        arregloFormatTipoParticipante3.push({nombre:this.itemsTipoGrupo1[i]['nombre'], mail:this.itemsTipoGrupo1[i]['mail'],
         nombreGrupo: this.nombreGrupo,idEncuesta:this.objEncuesta.idEncuesta,
        idTipoParticipante:this.idTipoParticipante, idCampus: this.idCampus, idDivision: idDivisionV,  idDependencia:this.idDepPlanUnidad,});	
      }
         var obj = {
          idEncuesta: this.objEncuesta.idEncuesta,
          idTipoParticipante:this.idTipoParticipante,
          nombreGrupo:this.nombreGrupo,
          idCampus: this.idCampus,
          idDivision: idDivisionV,
          idDependencia:this.idDepPlanUnidad,
          numParticipantes:this.numeroParticipantes,
          idRelacion:this.idRelacion,
           nueTipoParticipante3:this.nueTipoParticipante3
          };
       response = await postEncuestaParticipanteTipoUno(arregloFormatTipoParticipante3);
      }
      else{
        if(this.idTipoParticipante==2){
    var reader = new FileReader();
    self.loadingSave = true;
    var arregloFormat =new Array();
    var arregloFormat2=new Array();
    var arregloFormat3=new Array();
      for (var i=0; i < (this.fileConvertido.length); i++) {
        arregloFormat.push({nombre:this.fileConvertido[i]['Nombre'], mail:this.fileConvertido[i]['Mail'], nombreGrupo: this.nombreGrupo,idEncuesta:this.objEncuesta.idEncuesta, idTipoParticipante:this.idTipoParticipante});	
      }
          response = await sendExcel(arregloFormat);
        }
        else{
          if(this.idTipoParticipante==3){
            this.numeroParticipantes=1;
            if(this.idRelacion==1){
            var obj = {
          idEncuesta: this.objEncuesta.idEncuesta,
          idTipoParticipante:this.idTipoParticipante,
          nombreGrupo:this.nombreGrupo,
          numParticipantes:this.numeroParticipantes,
          idRelacion:this.idRelacion,
          mail:this.correoTipoParticipante3,
          nua:this.nueTipoParticipante3,
          idCampus:this.idCampus,
          campus:this.campus,
          idDivision:this.idDivision,
          division:this.division,
          idDependencia:this.idDepPlanUnidad,
          dependencia:this.depPlanUnidad,
          nombre:this.nombreTipoParticipante3,
          envioCorreo:this.objEncuesta.envioCorreo
          };
            }
            if(this.idRelacion==2){
          var obj = {
          idEncuesta: this.objEncuesta.idEncuesta,
          idTipoParticipante:this.idTipoParticipante,
          nombreGrupo:this.nombreGrupo,
          numParticipantes:this.numeroParticipantes,
          idRelacion:this.idRelacion,
          mail:this.correoTipoParticipante3,
          nombre:this.nombreTipoParticipante3,
          nue:this.nueTipoParticipante3,
          envioCorreo:this.objEncuesta.envioCorreo
          };
            }    
       response = await postCrearEiEncuestaParticipanteTipo3(obj);
          }
        if(this.idTipoParticipante==4){
          var obj = {
          idEncuesta: this.objEncuesta.idEncuesta,
          idTipoParticipante:this.idTipoParticipante,
          nombreGrupo:this.nombreGrupo,
          numParticipantes:this.numeroParticipantes,
          nombre:this.nombreTipoParticipante4,
          mail:this.correoTipoParticipante4,
          envioCorreo:this.objEncuesta.envioCorreo
          };
           response = await postCrearEiEncuestaParticipanteTipo4(obj);
        }
        }
      }
        if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Grupo de participante guardado con éxito";
                self.snackbarColor = "success";
                self.dialog2=false;
                self.snackbar = true;
              //  self.fnOnSave();
                self.inicializarFormularioDef();         
              }
            } else {
              self.snackbarTexto = "FormParticipante: " + response.data.message+self.objGrupoParticipanteSave;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "FormParticipante: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "FormParticipante: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
     download() {
        const data = XLSX.utils.json_to_sheet(this.items)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, data, 'data')
        XLSX.writeFile(wb,'ParticipantesPlantilla.xlsx')
      },
      eliminarParticipante(correoSeleccionado){
      const mails = this.itemsTipoGrupo1.map(el => el.mail);
      const index=mails.indexOf(correoSeleccionado)
      this.itemsTipoGrupo1.splice(index,1);
      this.numeroParticipantes=this.itemsTipoGrupo1.length;
      },
    setIdTipoParticipante(objtipoParticipante){
      this.idTipoParticipante=objtipoParticipante.idTipoParticipante;
      this.descripcionParticipante=objtipoParticipante.descripcionParticipante;
      if(this.idTipoParticipante==3){
          this.nombreGrupo="Invitación Individual Comunidad UG";
      }
      if(this.idTipoParticipante==4){
        this.nombreGrupo="Invitación Individual Externos";
      }
      if(this.idTipoParticipante==1||this.idTipoParticipante==2){
        this.nombreGrupo=this.nombreGrupo;
      }
    }, 
    setIdRelacionUG(objtipoRelacion){
      this.idRelacion=objtipoRelacion.idRelacion;
      this.relacion=objtipoRelacion.relacion;
    }, 
      setIdCampus(objCampus){
      this.idCampus = objCampus.id;
      this.campus = objCampus.descripcion;
    },
    setIdDivision(objDivision){
      this.idDivision = objDivision.id;
      this.division = objDivision.descripcion;
    },
    setIdDepPlanUnidad(objDepPlanUnidad){
      this.idDepPlanUnidad = objDepPlanUnidad.id;
      this.depPlanUnidad = objDepPlanUnidad.descripcion;
    },    
    }
    };
</script>